module.exports = __webpack_public_path__ + "static/media/054-Ceilis.3f122a62.jpg";